import React from 'react';
import { get, useController, useFormContext } from 'react-hook-form';
import { Field, ToggleSwitch as ReactToggle } from '@panwds/react-ui';
/**
 * Renders a toggle connected to the form. All extra props will get passed to the toggle.
 */
export const Toggle = (props) => {
    const { name, label, description, tooltip, disabled, register = {}, defaultValue = false, showLabel, requiredAsterisk, ...rest } = props;
    const context = useFormContext();
    /* istanbul ignore next */
    if (context === null) {
        throw new Error('Attempted to render Toggle outside of a Form context. Make sure your component is rendered inside <Form>.');
    }
    const { formState } = context;
    const { field: { onChange, value } } = useController({
        name,
        defaultValue: defaultValue,
        rules: disabled ? {} : register
    });
    return (React.createElement(Field, { label: label, control: React.createElement(ReactToggle, { ...rest, disabled: disabled, checked: value, onClick: () => onChange(!value) }), error: get(formState.errors, name)?.message, description: description, tooltip: tooltip, disabled: disabled, showLabel: showLabel, requiredAsterisk: requiredAsterisk }));
};
//# sourceMappingURL=Toggle.js.map